// wishlistApi.ts
import axios from "axios";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";
import { getEncodedTimestamp } from "../utilities/dateUtils";

export const fetchWishlistAPI = (uid: any, d: any, mappingCodes: any) =>
  axios
    .post(`${PKSOFT_URLS.CUSTOMER.CHECKLIST}`, {
      uid: uid,
      mappingCodes: mappingCodes,
      d: getEncodedTimestamp(),
    })
    .then((r) => r.data);
